import * as IntentLauncher from 'expo-intent-launcher';
import Constants from 'expo-constants';
import i18n from '@/utils/i18n';
import { Alert, Linking, Platform } from 'react-native';
import { useCallback } from 'react';

const EXPO_PACKAGE_NAME = 'host.exp.exponent';

export const onViewSettings = () => {
  switch (Platform.OS) {
    case 'android':
      // Use this app's package name if available, otherwise fall back to
      // the Expo app's package name for development
      const pkg = Constants.expoConfig?.android?.package ?? EXPO_PACKAGE_NAME;

      IntentLauncher.startActivityAsync(
        IntentLauncher.ActivityAction.APPLICATION_DETAILS_SETTINGS,
        { data: `package:${pkg}` },
      );
      break;
    case 'ios':
      Linking.openURL('app-settings:');
      break;
  }
};

export const usePermissionDeniedAlert = () => {
  return useCallback((message: string) => {
    Alert.alert(i18n.t('permission_denied'), message, [
      {
        onPress: onViewSettings,
        text: i18n.t('view_settings'),
      },
      {
        style: 'cancel',
        text: i18n.t('cancel'),
      },
    ]);
  }, []);
};
